// TODO: Implement more complex business logic once mapping is ready.

export const getThresholdInfo = (
  value: number | null,
  t: (key: string) => string
): { message: string; colorScheme: string } | null => {
  if (value === null) return null;
  if (value < 1_300_000) return { message: t("FOA Del I - Under nasjonal terskelverdi"), colorScheme: "info" };
  if (value <= 2_200_000) return { message: t("FOA Del II - Over nasjonal terskelverdi"), colorScheme: "warning" };
  return { message: t("FOA Del III - Over EØS-terskelverdi"), colorScheme: "warning" };
};
